"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemotesImporterService = void 0;
var class_1 = require("../class");
var helpers_1 = require("../helpers");
var RemotesImporterService = /** @class */ (function (_super) {
    __extends(RemotesImporterService, _super);
    function RemotesImporterService() {
        var _this = _super.call(this) || this;
        _this.MfeAlreadyImportedBasePriority = 1000; //Priorità di base per i mfe già importati
        _this._enableSortWithPriority = true; //Flag di accensione/spegnimento della logica di sort
        _this.execQueue = []; //Lista di esecuzione con priorità
        _this.currentExecTask = null;
        return _this;
    }
    Object.defineProperty(RemotesImporterService.prototype, "isExecuting", {
        get: function () {
            return this.currentExecTask != null;
        },
        enumerable: false,
        configurable: true
    });
    RemotesImporterService.prototype.addInExecQueue = function (execObj) {
        helpers_1.ConsoleHelper.info("[RemotesImporterService] Added in Exec Queue", JSON.stringify(execObj));
        this.execQueue.push(execObj);
        if (this._enableSortWithPriority)
            this.execQueue.sort(function (a, b) { return a.priority - b.priority; });
        helpers_1.ConsoleHelper.info.apply(helpers_1.ConsoleHelper, __spreadArray(__spreadArray(["CurrentExecQueueStatus ["], this.execQueue.map(function (execObj) { return "".concat(execObj.__mfeName__, " priority: ").concat(execObj.priority); }), false), ["]"], false));
        if (!this.isExecuting) {
            this.execNextTask();
        }
        return null;
    };
    RemotesImporterService.prototype.execNextTask = function () {
        if (this.execQueue.length > 0) {
            this.startExecution();
        }
        else {
            this.stopExecution();
        }
    };
    RemotesImporterService.prototype.startExecution = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                helpers_1.ConsoleHelper.info("[RemotesImporterService] [startExecution] Start Execution of import remotes");
                this.currentExecTask = this.execAll();
                return [2 /*return*/];
            });
        });
    };
    RemotesImporterService.prototype.stopExecution = function () {
        helpers_1.ConsoleHelper.info("[RemotesImporterService] [stopExecution] Stop execution of import remotes");
        this.currentExecTask = null;
    };
    RemotesImporterService.prototype.execAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exec()];
                    case 1:
                        _a.sent();
                        this.execNextTask();
                        return [2 /*return*/, null];
                }
            });
        });
    };
    RemotesImporterService.prototype.exec = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, __mfeName__, isClientSideImport, resolve, reject, priority, remote, remote, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.execQueue.length > 0)) return [3 /*break*/, 8];
                        _a = this.execQueue.pop(), __mfeName__ = _a.__mfeName__, isClientSideImport = _a.isClientSideImport, resolve = _a.resolve, reject = _a.reject, priority = _a.priority;
                        helpers_1.ConsoleHelper.info("[RemotesImporterService] Executing with priority ".concat(priority), __mfeName__, isClientSideImport);
                        helpers_1.ConsoleHelper.info.apply(helpers_1.ConsoleHelper, __spreadArray(__spreadArray(["ExecQueueStatus after pop ["], this.execQueue.map(function (execObj) { return "".concat(execObj.__mfeName__, " priority: ").concat(execObj.priority); }), false), ["]"], false));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        if (!!this.isAlreadyImported(__mfeName__, isClientSideImport)) return [3 /*break*/, 5];
                        if (!isClientSideImport) return [3 /*break*/, 2];
                        // don't block the queue -> the import of remotes is in parallel for client side
                        resolve(this.execImportRemoteBy(__mfeName__, isClientSideImport));
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.execImportRemoteBy(__mfeName__, isClientSideImport)];
                    case 3:
                        remote = _b.sent();
                        resolve(remote);
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        remote = this.getRemote(__mfeName__, isClientSideImport);
                        resolve(remote);
                        _b.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _b.sent();
                        reject("[RemotesImporterService] ERROR: IMPORT ".concat(__mfeName__, " REMOTE \n ").concat(error_1));
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, null];
                }
            });
        });
    };
    RemotesImporterService.prototype.execImportRemoteBy = function (__mfeName__, isClientSideImport) {
        return __awaiter(this, void 0, void 0, function () {
            var execImport;
            var _this = this;
            return __generator(this, function (_a) {
                execImport = this.getExecImport(__mfeName__);
                if (!execImport) {
                    execImport = helpers_1.ExecutionHelper.stopExecutionAfter(function () { return _this.importRemoteBy(__mfeName__); }, helpers_1.EnvironmentHelper.isRunningTest() ? 100 : 120000, "[RemotesImporterService] [startExecution] Timeout Error: Execution of ".concat(__mfeName__, " has took too long!")).then(function (remote) {
                        _this.setRemote(remote, isClientSideImport);
                        return remote;
                    });
                    this.setExecImport(__mfeName__, execImport);
                }
                return [2 /*return*/, execImport];
            });
        });
    };
    RemotesImporterService.prototype.getRemote = function (__mfeName__, isClientSideImport) {
        throw new Error("Method getRemote not implemented.");
    };
    RemotesImporterService.prototype.setRemote = function (remote, isClientSideImport) {
        throw new Error("Method setRemote not implemented.");
    };
    RemotesImporterService.prototype.getExecImport = function (__mfeName__) {
        throw new Error("Method getExecImport not implemented.");
    };
    RemotesImporterService.prototype.setExecImport = function (__mfeName__, execPromise) {
        throw new Error("Method setExecImport not implemented.");
    };
    RemotesImporterService.prototype.isAlreadyImported = function (__mfeName__, isClientSideImport) {
        throw new Error("Method isAlreadyImported not implemented.");
    };
    RemotesImporterService.prototype.importRemoteBy = function (__mfeName__) {
        throw new Error("Method importRemoteBy not implemented.");
    };
    RemotesImporterService.className = "RemotesImporterService";
    return RemotesImporterService;
}(class_1.Singleton));
exports.RemotesImporterService = RemotesImporterService;
